<template>
  <app-collapse
    accordion
    :type="collapseType"
    class="client-items"
  >

    <app-collapse-item
      v-if="subscriptionItems.length > 0"
      :title="$t('DEBTIA_SUBSCRIPTIONS')"
    >
      <b-overlay
        id="overlay-background"
        :show="Mloader"
        variant="dark"
        opacity="0.85"
        blur="2px"
        rounded="sm"
        spinner-variant="primary"
        spinner-medium
      >
        <b-table
          ref="roles"
          class="position-relative"
          :fields="subscriptionFields"
          :items="subscriptionItems"
          responsive
          :tbody-tr-class="rowClass"
        >
          <template #cell(type)="data">
            <span :class="getTextColor(data.item)">{{ $t(data.item.type) }}</span>
          </template>
          <template #cell(start_date)="data">
            <span :class="getTextColor(data.item)">{{ $t(data.item.start_date) }}</span>
          </template>
          <template #cell(end_date)="data">
            <span :class="getTextColor(data.item)">{{ $t(data.item.end_date) }}</span>
          </template>
          <template #cell(number)="data">
            <span :class="getTextColor(data.item)">{{ $t(data.item.number) }}</span>
          </template>
          <template #cell(cancelled)="data">
            <span :class="getTextColor(data.item)">{{ $t(data.item.cancelled) }}</span>
          </template>
          <template #cell(auto_renew)="data">
            <span :class="getTextColor(data.item)">{{ $t(data.item.auto_renew) }}</span>
          </template>
          <template #cell(actions)="data">
            <feather-icon
              v-if="$ability.can(constants.action.permissionEditSubscription, constants.resource.user)"
              icon="EditIcon"
              :class="['cursor-pointer', getTextColor(data.item)]"
              @click="EditSubscription(data.item)"
            />
          </template>
        </b-table>
      </b-overlay>
      <edit-subscription
        ref="editSubscription"
        :edit-subscription="EditSelectedSubscription"
        :user-data="userData"
      />
    </app-collapse-item>
    <app-collapse-item
      :title="$t('DEBTIA_DEBT_CASES')"
      class="cases-table"
    >
      <div class="table-container">
        <div class="d-flex justify-content-end mb-2">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            :disabled="selectedCases.length === 0"
            @click="showMergeModal"
          >
            {{ $t('DEBTIA_MERGE') }}
          </b-button>
        </div>
        <b-overlay
          id="overlay-background"
          :show="Mloader"
          variant="dark"
          opacity="0.85"
          blur="2px"
          rounded="sm"
          spinner-variant="primary"
          spinner-medium
        >
          <b-table
            ref="refUserListTable"
            class="position-relative resource-listing"
            :items="caseItems"
            responsive
            :fields="caseFields"
            primary-key="id"
            :sort-by.sync="sortBy"
            show-empty
            empty-text="No matching records found"
            :sort-desc.sync="isSortDirDesc"
            selectable
            @row-selected="onRowSelected"
          >

            <!-- Column: Company -->
            <!-- <template
          v-if="1 < 0"
          #cell(company)="{data}"
        >
          {{ data.item.company }}
        </template> -->

            <!-- Column: Role -->
            <template #cell(id)="data">
              <b-link
                :to="{ name: 'case-details', params: { id: data.item.id } }"
                target="_blank"
              >
                <div>
                  {{ (data.item.g_prefix) ? data.item.g_prefix+data.item.id : data.item.id }}
                </div>
              </b-link>
            </template>

            <template #cell(base_type)="data">
              <b-link
                :to="{ name: 'case-details', params: { id: data.item.id } }"
                target="_blank"
              >
                <div>{{ (data.item.base_type) ? data.item.base_type.name : '' }}</div>
              </b-link>
            </template>

            <template #cell(debtor_name)="data">
              <b-media vertical-align="center">
                <b-link
                  class="font-weight-bold d-block text-nowrap client-name"
                  :to="{ name: 'case-details', params: { id: data.item.id } }"
                  target="_blank"
                >
                  <div>
                    <div>{{ getDebtorName(data.item.get_debtors[0]) }}</div>
                  </div>
                </b-link>
              </b-media>
            </template>
            <template #cell(case_group)="data">
              <b-link
                :to="{ name: 'case-details', params: { id: data.item.id } }"
                target="_blank"
              >
                <div>{{ (data.item.debt_case_group) ? data.item.debt_case_group.title : 'N/A' }}</div>
              </b-link>
            </template>
            <template #cell(active_process)="data">
              <b-link
                :to="{ name: 'case-details', params: { id: data.item.id } }"
                target="_blank"
              >
                <div>{{ (data.item.process_case && (data.item.process_case.length > 0 && data.item.process_case[0].completed == 0)) ? data.item.process_case[0].process.title : $t('DEBTIA_DEBT_CASE_ACTIVE_PROCESS') }}</div>
              </b-link>
            </template>
            <template #cell(status)="data">
              <b-link
                :to="{ name: 'case-details', params: { id: data.item.id } }"
                target="_blank"
              >
                <b-badge
                  v-if="data.item.status === 0 || data.item.status === null"
                  pill
                  variant="warning"
                >
                  {{ $t('DEBTIA_PENDING') }}
                </b-badge>
                <b-badge
                  v-if="data.item.status === 1"
                  pill
                  variant="success"
                >
                  {{ $t('DEBTIA_ACCEPTED') }}
                </b-badge>
                <b-badge
                  v-if="data.item.status === 2"
                  pill
                  variant="danger"
                >
                  {{ $t('DEBTIA_DECLINED') }}
                </b-badge>
                <b-badge
                  v-if="data.item.status === 3"
                  pill
                  variant="danger"
                >
                  {{ $t('DEBTIA_TERMINATED') }}
                </b-badge>
                <b-badge
                  v-if="data.item.status === 4"
                  pill
                  variant="warning"
                >
                  {{ $t('DEBTIA_PAUSED') }}
                </b-badge>
              </b-link>
            </template>
            <template #head(checkbox)="">
              <b-form-checkbox
                id="main_checkbox1"
                v-model="header_check"
              />
            </template>
            <template #cell(checkbox)="data">
              <b-link
                :to="{ name: 'case-details', params: { id: data.item.id } }"
                target="_blank"
              >
                <b-form-checkbox
                  :id="`checkbox_${data.item.id}`"
                  v-model="caseSelection[`checkbox_${data.item.id}`].check"
                  class="checkbox-align"
                  @change="caseCheckBoxClicked($event, data.item.id)"
                />
              </b-link>
            </template>
          </b-table>
        </b-overlay>
      </div></app-collapse-item>

    <app-collapse-item
      :title="$t('DEBTIA_INVOICES')"
    >
      <b-table
        ref="refUserListTable"
        class="position-relative"
        :items="fetchInvoices"
        responsive
        :fields="invoicesColumns"
        primary-key="id"
        :sort-by.sync="sortBy"
        show-empty
        empty-text="No matching records found"
        :sort-desc.sync="isSortDirDesc"
        selectable
        @row-selected="onInvoiceSelected"
      >
        <template #cell(invoice_bc_id)="data">

          <b-badge
            :variant="data.item.bc_approved ? 'light-success' : 'light-warning'"
          >
            {{ data.item.invoice_bc_id }}
          </b-badge>
        </template>
        <template
          #cell(invoice_date)="data"
        >
          {{ formattedDate(data.item.invoice_date) }}
        </template>
        <template
          #cell(due_date)="data"
        >
          {{ formattedDate(data.item.due_date) }}
        </template>
        <template
          #cell(total)="data"
        >
          {{ formatCurrency(data.item.total) }}
        </template>
        <template #cell(paid)="data">
          <b-link
            v-if="data.item.case_id"
            class="font-weight-bold d-block text-nowrap"
            :href="'/cases/details/v2/'+data.item.case_id"
            target="_blank"
          >
            <b-badge
              :variant="data.item.paid ? 'light-success' : 'light-danger'"
            >
              {{
                !data.item.bc_approved ? 'Not Approved'
                : data.item.paid ? 'Paid'
                  : data.item.case_id ? 'Case Runnig ' + data.item.case_id : 'Unpaid'
              }}
            </b-badge>
          </b-link>
          <b-badge
            v-else
            :variant="data.item.paid ? 'light-success' : 'light-danger'"
          >
            {{
              !data.item.bc_approved ? 'Not Approved'
              : data.item.paid ? 'Paid'
                : data.item.case_id ? 'Case Runnig ' + data.item.case_id : 'Unpaid'
            }}
          </b-badge>
        </template>
        <!-- Column: Company -->
        <!-- <template
          v-if="1 < 0"
          #cell(company)="{data}"
        >
          {{ data.item.company }}
        </template> -->

        <!-- Column: Role -->
        <!-- Column: Actions -->
      </b-table>
    </app-collapse-item>

    <app-collapse-item
      :title="$t('DEBTIA_DEBTORS')"
    >
      <b-table
        ref="refUserListTable"
        class="position-relative"
        :items="debtorItems"
        responsive
        :fields="debtorFields"
        primary-key="id"
        :sort-by.sync="sortBy"
        show-empty
        :empty-text="$t('DEBTIA_NO_RECORD_MSG')"
        :sort-desc.sync="isSortDirDesc"
        selectable
        @row-selected="onDebtorSelected"
      >

        <!-- Column: Company -->
        <!-- <template
          v-if="1 < 0"
          #cell(company)="{data}"
        >
          {{ data.item.company }}
        </template> -->

        <!-- Column: Role -->
        <!-- Column: Actions -->
        <template #cell(action)="data">
          <b-link
            class="nav-link"
            :to="{ name: 'debtor-edit', params: { id: data.item.id } }"
            target="_blank"
          >
            <feather-icon
              icon="EyeIcon"
              style="margin-left: 15px;"
            />
          </b-link>
        </template>

      </b-table>
    </app-collapse-item>

    <app-collapse-item
      :title="$t('DEBTIA_FILES')"
    >
      <b-overlay
        id="overlay-background"
        :show="fileloader"
        variant="dark"
        opacity="0.85"
        blur="2px"
        rounded="sm"
        spinner-variant="primary"
        spinner-medium
      >
        <b-row>
          <b-col
            cols="12"
            offset-md="6"
            md="6"
            class="query-input"
          >
            <div class="d-flex align-items-center justify-content-end">
              <b-button
                id="add-file-btn"
                v-b-modal.modal-add-file
                variant="primary"
              >
                <span class="text-nowrap">{{ $t('DEBTIA_ADD_FILE') }}</span>
              </b-button>
            </div>
          </b-col>
        </b-row>
        <b-table
          :items="fileItems"
          :fields="fileFields"
          striped
          responsive
          class="mb-0"
          show-empty
          :empty-text="$t('DEBTIA_NO_RECORD_MSG')"
        >
          <template #cell(show_details)="row">

            <!-- As `row.showDetails` is one-way, we call the toggleDetails function on @change -->
            <b-button
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              variant="outline-primary"
              @click="row.toggleDetails"
            >
              {{ row.detailsShowing ? $t('DEBTIA_HIDE') : $t('DEBTIA_SHOW') }}
            </b-button>
          </template>

          <!-- full detail on click -->
          <template #row-details="row">
            <b-card>
              <b-row class="mb-2 detailcard">
                <b-col
                  md="12"
                  class="mb-1"
                >
                  <table class="filetable">
                    <tbody>
                      <tr>
                        <td class="pr-1 filecolumn">
                          <span class="font-weight-bold"> {{ $t('DEBTIA_DESCRIPTION') }} </span>
                        </td>
                        <td> {{ row.item.description ? row.item.description : $t('DEBTIA_NOT_AVAILABLE') }}</td>
                      </tr>
                      <tr>
                        <td class="pr-1 filecolumn">
                          <span class="font-weight-bold"> {{ $t('DEBTIA_FILE') }}: </span>
                        </td>
                        <td>
                          <b-button
                            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                            variant="outline-primary"
                            :href="row.item.file_link"
                            target="_blank"
                            download
                          >
                            {{ $t('DEBTIA_FILE') }}
                          </b-button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </b-col>
              </b-row>

              <b-button
                size="sm"
                variant="outline-secondary"
                @click="row.toggleDetails"
              >
                {{ $t('DEBTIA_HIDE_DETAILS') }}
              </b-button>
            </b-card>
          </template>

          <template #cell(avatar)="data">
            <b-avatar :src="data.value" />
          </template>

          <template #cell(status)="data">
            <b-badge :variant="status[1][data.value]">
              {{ status[0][data.value] }}
            </b-badge>
          </template>
        </b-table>
      </b-overlay>
      <file-modal @fileadded="refreshfiles" />
    </app-collapse-item>
    <notes-section
      :person-type="1"
    />
    <debtor-compare
      :user-data="userData"
      :selected-cases="selectedCases"
      :merge-cases-items="mergeCasesItems"
      @update:mergeCaseItems="mergeCaseItems = $event"
    />
  </app-collapse>
</template>

<script>
import {
  BTable, BButton, BCol, BRow, BCard, BOverlay, BLink, BBadge, BMedia, BFormCheckbox,
} from 'bootstrap-vue'
import axios from '@axios'
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue'
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue'
import i18n from '@/libs/i18n'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import Ripple from 'vue-ripple-directive'
import NotesSection from '@/views/commonfiles/NotesSection.vue'
import constants from '@/app-configs/constants'
import { EventBus } from '@/event-bus'
import FileModal from './FileModal.vue'
import DebtorCompare from './DebtorCompare.vue'
import EditSubscription from './EditSubscription.vue'

export default {
  components: {
    AppCollapse, AppCollapseItem, BTable, BButton, FileModal, BCol, BRow, BCard, BOverlay, BLink, BBadge, BMedia, NotesSection, BFormCheckbox, DebtorCompare, EditSubscription,
  },
  directives: {
    Ripple,
  },
  props: {
    userData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      sortBy: 'DESC',
      isSortDirDesc: true,
      fileItems: this.userData.data.client_files,
      fileloader: false,
      header_check: false,
      caseSelection: {},
      selectedCases: [],
      mergeCasesItems: {},
      EditSelectedSubscription: {},
      Mloader: false,
      constants,
      payment_client_id: '',
      payment_secret: '',
      defaultCurrency: localStorage.getItem('defaultCurrency') || 'DKK',
      debtorFields: [{ key: 'id', sortable: true }, { key: 'name', sortable: false, label: this.$t('DEBTIA_NAME') }],
      // caseFields: ['id', { key: 'base_type', sortable: false, label: this.$t('DEBTIA_BASE_TYPE') }, { key: 'bc_case_id', sortable: false, label: this.$t('DEBTIA_BC_ID') }],
      caseFields: [
        { key: 'id', sortable: true },
        { key: 'base_type', sortable: true, label: i18n.t('DEBTIA_BASE_TYPE') },
        { key: 'debtor_name', sortable: true, label: i18n.t('DEBTIA_DEBTOR_NAME') },
        { key: 'case_group', label: i18n.t('DEBTIA_CASE_GROUP') },
        { key: 'active_process', label: i18n.t('DEBTIA_ACTIVE_PROCESS') },
        { key: 'status', label: i18n.t('DEBTIA_STATUS') },
        { key: 'checkbox' },
        // { key: 'action', label: i18n.t('DEBTIA_ACTION') },
      ],
      // subscriptionFields: [
      //   { key: 'type', sortable: false, label: this.$t('DEBTIA_TYPE') },
      //   { key: 'start_date', sortable: false, label: this.$t('DEBTIA_START_DATE') },
      //   { key: 'end_date', sortable: false, label: this.$t('DEBTIA_END_DATE') },
      //   { key: 'number', sortable: false, label: this.$t('DEBTIA_NUMBER') },
      //   { key: 'cancelled', sortable: false, label: this.$t('DEBTIA_CANCELLED') },
      //   { key: 'auto_renew', sortable: false, label: this.$t('DEBTIA_AUTO_RENEW') },
      // ],
      fileFields: ['id', 'title', 'show_details'],
      debtorItems: this.userData.data.debtors,
      caseItems: this.userData.data.debt_case,
      subscriptionItems: this.userData.data.subscriptions,
      fetchInvoices: [],
      // fetchInvoices: this.userData.data.invoices,
    }
  },
  setup() {
    const collapseType = 'margin'
    const fetchClients = []
    return {
      collapseType,
      fetchClients,
    }
  },
  computed: {
    subscriptionFields() {
      const temp = [
        // eslint-disable-next-line object-curly-newline
        { key: 'type', sortable: false, label: this.$t('DEBTIA_TYPE') },
        // eslint-disable-next-line object-curly-newline
        { key: 'start_date', sortable: false, label: this.$t('DEBTIA_START_DATE') },
        // eslint-disable-next-line object-curly-newline
        { key: 'end_date', sortable: false, label: this.$t('DEBTIA_END_DATE') },
        // eslint-disable-next-line object-curly-newline
        { key: 'number', sortable: false, label: this.$t('DEBTIA_NUMBER') },
        // eslint-disable-next-line object-curly-newline
        { key: 'cancelled', sortable: false, label: this.$t('DEBTIA_CANCELLED') },
        // eslint-disable-next-line object-curly-newline
        { key: 'auto_renew', sortable: false, label: this.$t('DEBTIA_AUTO_RENEW') },
      ]
      if (this.$ability.can(constants.action.permissionEditSubscription, constants.resource.user)) {
        temp.push({
          key: 'actions', sortable: false, label: this.$t('DEBTIA_ACTION'),
        })
      }

      return temp
    },
    invoicesColumns() {
      const temp = [
        { key: 'invoice_bc_id', sortable: true, label: i18n.t('INVOICE_BC_ID') },
        { key: 'invoice_date', sortable: true, label: i18n.t('DEBTIA_INVOICE_DATE') },
        { key: 'due_date', sortable: true, label: i18n.t('DEBTIA_DUE_DATE') },
        { key: 'total', sortable: true, label: i18n.t('DEBTIA_TOTAL') },
        { key: 'paid', sortable: true, label: i18n.t('DEBTIA_STATUS') },
      ]

      if (this.role === 'super-admin') {
        temp.splice(
          1, 0, { key: 'company', sortable: false, label: this.$t('DEBTIA_COMPANY') },
        )
      }

      return temp
    },
  },
  watch: {
    header_check: {
      handler() {
        this.selectedCases = []
        Object.keys(this.caseSelection).forEach(element => {
          this.caseSelection[element].check = this.header_check
          if (this.header_check) {
            this.selectedCases.push(this.caseSelection[element].id)
          }
        })
      },
    },
    userData: {
      handler() {
        this.Mloader = true
        this.caseItems = this.userData.data.debt_case
        this.subscriptionItems = this.userData.data.subscriptions
        setTimeout(() => {
          this.Mloader = false
        }, 1000)
      },
    },
  },
  created() {
    this.subscriptionRowColors()
    this.getPaymentsApiSettings()
    this.caseItems.forEach(item => {
      this.caseSelection[`checkbox_${item.id}`] = { id: item.id, check: false }
    })
    EventBus.$on('merge-success', this.resetCheckboxes)
  },
  beforeDestroy() {
    EventBus.$off('merge-success', this.resetCheckboxes)
  },
  methods: {
    async getPaymentsApiSettings() {
      await axios.get('/settings/get?module=payments').then(settings => {
        if (settings.status) {
          this.payment_client_id = settings.data.data.client_id
          this.payment_secret = settings.data.data.secret
          this.getInvoices()
        }
      }).catch(err => {
        console.log(err)
      })
    },
    formattedDate(date) {
      if (!date) return 'Invalid date' // Return an empty string if date is not provided
      // Convert the date to a string if it's not already one
      const dateString = String(date)
      // Check if the date string is in the correct format (YYYY-MM-DD)
      if (dateString.includes('-')) {
        const [year, month, day] = dateString.split('-')
        return `${day}-${month}-${year}`
      }
      // Handle invalid date format or other cases
      return 'Invalid date'
    },
    formatCurrency(amount) {
      return new Intl.NumberFormat('da-DK', { style: 'currency', currency: this.defaultCurrency }).format(parseFloat(amount).toFixed(2))
    },
    onInvoiceSelected(item) {
      window.open(`/clients/view-invoice/${item[0].id}`, '_blank')
    },
    async getInvoices() {
      const clientId = this.$route.params.id
      const headers = {
        clientId: this.payment_client_id,
        secret: this.payment_secret,
      }
      await axios.get(`${constants.paymentsBaseUrl}/external/invoice-system/get-client-invoices/${clientId}`, {
        headers,
      }).then(response => {
        if (response.status === 200) {
          this.fetchInvoices = response.data.data
          // this.getHistory()
        }
      }).catch(error => {
        console.log(error)
        // this.historyLoader = false
        // this.errorMessage = error.response.data.message
      })
    },
    getDebtorName(debtor) {
      return debtor ? debtor.name : 'N/A'
    },
    rowClass(item) {
      return item.colorclass
    },
    getTextColor(item) {
      return item.color === null ? 'fontGrey' : 'fontWhite'
    },
    subscriptionRowColors() {
      this.subscriptionItems.forEach(element => {
        // eslint-disable-next-line no-underscore-dangle, no-param-reassign
        element._rowVariant = element._rowvariant
      })
    },
    onRowSelected(item) {
      this.selected = item
      this.$router.push(`/cases/details/v2/${item['0'].id}`)
    },
    onDebtorSelected(item) {
      this.selected = item
      this.$router.push(`/debtors/view/${item['0'].id}`)
    },
    refreshfiles() {
      this.fileloader = true
      const clientId = this.$route.params.id
      axios.get(`/clients/view?id=${clientId}`).then(response => {
        if (response.status === 200) {
          this.title = ''
          this.fileItems = response.data.data.client_files
          this.fileloader = false
        }
      })
    },
    resetCheckboxes() {
      this.header_check = false
      this.selectedCases = []
      Object.keys(this.caseSelection).forEach(key => {
        this.caseSelection[key].check = false
      })
    },
    caseCheckBoxClicked(value, id) {
      if (value) {
        this.selectedCases.push(id)
      } else {
        const indexToRemove = this.selectedCases.indexOf(id)
        if (indexToRemove !== -1) {
          this.selectedCases.splice(indexToRemove, 1)
        }
      }
    },
    showMergeModal() {
      if (this.selectedCases.length <= 1) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: i18n.t('Error'),
            icon: 'AlertCircleIcon',
            variant: 'danger',
            text: i18n.t('DEBTIA_SELECT_AT_LEAST_TWO_CASES'),
          },
        })
        return
      }
      const url = `${constants.baseUrl}/debt-cases/debtors/get`
      axios.post(url, {
        creditor_id: this.$route.params.id || null,
        case_ids: this.selectedCases || null,
      }).then(response => {
        if (response.status === 200) {
          this.mergeCasesItems = response.data.data
        }
      })
      this.$root.$emit('bv::show::modal', 'compare-cases-modal')
    },
    EditSubscription(item) {
      this.EditSelectedSubscription = item
      this.$refs.editSubscription.$children[0].show()
    },
  },
}
</script>

<style>
#add-file-btn {
  margin-bottom: 10px;
}

.detailcard {
  margin: 20px;
}

.filecolumn {
  width: 15%;
}

.filetable {
  width: 100%;
}

.bluecolor {
  background-color: #00a1b5;
  color: white !important;
}

.redcolor {
  background-color: #e42728;
  color: white !important;
}

.greencolor {
  background-color: #1f9d57;
  color: white !important;
}

.fontWhite {
  color: white !important;
}

.fontGrey {
  color: #6c757d !important;
}

.cases-table .card-body {
  overflow-y: scroll;
  /* Ensure the inner div doesn't exceed the container */
  max-height: 500px;
  padding-right: 10px;
}
.cases-table .card-body::-webkit-scrollbar {
    width: 12px;
}
.cases-table .card-body::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
    border-radius: 10px;
}
.cases-table .card-body::-webkit-scrollbar-thumb {
    border-radius: 10px;
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.5);
}
.checkbox-align  .custom-control-label {
  position: absolute;
  left: 50%;
}
</style>
